// ------------------------------------
// EXIBIÇÃO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'slide-var';
    const ref2 = 'slide';
    const refEvtPrefix = 'lp-evt-slide-';

    // Elementos
    const $section = $('#slide');

    // Oculta/Exibe a seção
    function changeSecShow() {
      const value = confTheme[ref2]['slide-show'];
      value == '1' ? $section.removeClass('d-none') : $section.addClass('d-none');
      if (value == '1') {
        slideDestroySlick();
        slideInitSlick();
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'show', changeSecShow);
  }
})();

// ------------------------------------
// PLANO DE FUNDO
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'slide-var';
    const ref2 = 'slide';
    const refEvtPrefix = 'lp-evt-slide-';

    // Elementos
    const $section = $('#slide');

    // Altera a cor de fundo
    function changeBgColor() {
      const color = confTheme[ref]['slide-bg-color'];
      $section.css('background-image', 'none');
      $section[0].style.setProperty('--slide-bg-color', color);
    }
    $root.on(refEvtPrefix + 'bg-color', changeBgColor);
  }
})();

// ------------------------------------
// DIVISOR
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'slide-var';
    const ref2 = 'slide';
    const refEvtPrefix = 'lp-evt-slide-';

    // Altera o divisor
    function changeDivider() {
      const value = confTheme[ref2]['divisor'];
      $('.slide .section-divider').addClass('d-none');
      if (value) {
        $('.slide .section-divider.' + value).removeClass('d-none');
        $('#slide-lista').trigger('change-divider');
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor', changeDivider);

    // Altera a cor do divisor
    function changeDividerColor() {
      const color = confTheme[ref]['divisor-color'];
      $('#slide')[0].style.setProperty('--divisor-color', color);
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'divisor-color', changeDividerColor);
  }
})();

// ------------------------------------
// LISTA DE BANNERS
// ------------------------------------
(function () {
  'use strict';
  if (previewMode) {
    // Variáveis
    const ref = 'slide-var';
    const ref2 = 'slide';
    const refEvtPrefix = 'lp-evt-slide-';

    // Elementos
    const $list = $('#slide-lista');

    // Altera a lista
    function changeList() {
      const lista = confTheme[ref2]['lista'];
      if ($list.length > 0) {
        slideDestroySlick();
        $list.html('');
        for (let i = 0; i < lista.length; i++) {
          const imgMb = lista[i].img_mobile ? lista[i].img_mobile : lista[i].img;
          const $contentSlide =
            lista[i]['show-content'] == 1
              ? `<div class="img-overlay">
            <div class="container text-center">
              <div class="title slide-title">${lista[i].titulo}</div>
              <div class="slide-text md-text">${fmtTxt(lista[i].texto, true)}</div>
            </div>
          </div>`
              : '';
          const item = `
          <li class="carousel-item">
            <a href="${lista[i].url}" class="slide-item">
              <img class="d-none-sm d-none-xs" src="${lista[i].img}" alt="${lista[i].alt}">
              <img class="d-none-xl d-none-lg d-none-md" src="${imgMb}" alt="${lista[i].alt}">
              ${$contentSlide}
            </a>
          </li>`;
          const $item = $(item);
          $item[0].style.setProperty('--slide-tit-color', lista[i]['tit-color']);
          $item[0].style.setProperty('--slide-txt-color', lista[i]['txt-color']);
          $list.append($item);
        }
        slideInitSlick();
        setTimeout(() => {
          $list[0].slick.refresh();
        }, 500);
      }
    }
    $root.on(confEvtDefault + ' ' + refEvtPrefix + 'lista', changeList);
  }
})();
